/* TODO: t() */
import React, { ComponentProps, useState, useCallback } from 'react';
import { StyleSheet, StyleProp, TextStyle } from 'react-native';

import createTextComponent from '../../support/rn-web/createTextComponent';

const Text = createTextComponent({
  tagName: 'a',
  additionalProps: {
    tabIndex: true,
    className: true,
  },
});

type TextProps = ComponentProps<typeof Text>;

type Props = TextProps & {
  target?: '_blank' | '_top' | '_self';
  download?: boolean;
  hoverStyle?: StyleProp<TextStyle>;
  allowOpener?: boolean;
  children?: React.ReactNode;
};

export default function Link(props: Props) {
  let {
    href,
    target,
    download,
    style,
    hoverStyle,
    allowOpener,
    ...otherProps
  } = props;
  let [isHovered, setHovered] = useState(false);
  let isLocal = isLocalURL(href);
  let rel: string | undefined;
  if (!isLocal) {
    target = target || '_blank';
    rel = allowOpener ? 'opener' : 'noopener noreferrer';
  }
  let onMouseEnter = useCallback(() => {
    setHovered(true);
  }, []);
  let onMouseLeave = useCallback(() => {
    setHovered(false);
  }, []);
  return (
    <Text
      {...otherProps}
      style={[styles.link, style, isHovered && hoverStyle]}
      onPress={(event) => {
        if (isLocal && target == null) {
          event.preventDefault();
        }
        if (props.onPress) {
          props.onPress(event);
        }
      }}
      href={href || '#'}
      hrefAttrs={{ target, rel, download }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
}

let styles = StyleSheet.create({
  link: {
    color: '#5080a8',
  },
});

function isLocalURL(url: string | null | undefined): boolean {
  if (url == null) {
    return true;
  }
  switch (url.charAt(0)) {
    case '#':
    case '/':
    case '.':
      return true;
    default:
      return false;
  }
}
